import Vue from 'vue'

import VueOffline from 'vue-offline'
import App from './App.vue'
//import Vuex from 'vuex'
import store from './store'
import router from './router'

import 'vuetify/dist/vuetify.min.css'
import vuetify from '@/plugins/vuetify'
import i18n from '@/plugins/i18n'

//import 'mdi/css/materialdesignicons.min.css'

import '@/plugins/geolocation'
import '@/registerServiceWorker'




Vue.config.productionTip = false

Vue.use(VueOffline)


new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
